import type { PropsWithChildren } from 'react'
import { cn } from '@/lib/utils'

interface PanelTitleProps extends PropsWithChildren {
  className?: string
}

export function PanelTitle({ children, className }: PanelTitleProps) {
  return (
    <h2 className={cn('text-[var(--brand-slate-1)] font-bold', className)}>
      {children}
    </h2>
  )
}
